import { UFOExperienceState } from '@atlassian/ufo';
import {
  setOnStartChangesetStats,
  setOnEndChangesetStats,
} from '@databases/collab-state-manager/collab-manager';
import { CollabChangeExperiences } from '@databases/frontend-metrics';

setOnStartChangesetStats(() => {});

setOnEndChangesetStats(async (stats) => {
  for (const [experienceName, data] of Object.entries(stats)) {
    const experience =
      CollabChangeExperiences[experienceName as keyof typeof CollabChangeExperiences];
    if (!experience) {
      return;
    }

    await experience.transition(UFOExperienceState.STARTED, 0);
    experience.addMetadata(data);
    await experience.transition(UFOExperienceState.SUCCEEDED, data.avg);
  }
});
